import React, { useEffect, useState } from 'react';
import {
  Button,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classnames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import CreateBrandPopup from './brand/CreateBrandPopup';
import ModifyOrganization from './ModifyOrganization';
import CampaignTypeForm from './CampaignTypeForm';
import CampaignTypeList from './CampaignTypeList';
import AvailableStores from './AvailableStores';

const OrganizationManagement = () => {
  const organization = useSelector((state) => state?.organization);
  const { organizationTree, countries } = organization || {};
  const { brands } = organizationTree;

  const [activeTab, setActiveTab] = useState('1');
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const handleBrandClick = (brand) => {
    try {
      setSelectedBrand(brand);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    try {
      if (selectedBrand?.brandId) {
        setSelectedCountry(selectedBrand?.countryList?.[0] || null);
      }
    } catch (e) {
      console.log(e);
    }
  }, [selectedBrand]);

  useEffect(() => {
    setSelectedBrand(brands?.[0]);
  }, [organizationTree]);

  return (
    <div className="page-content px-4 pb-0">
      <Row>
        <Col md={12} className="m-auto">
          <div
            style={{ backdropFilter: 'blur(4px)' }}
            className="position-sticky top-0 z-1 d-flex justify-content-between align-items-center py-4 border-bottom"
          >
            <h4 className="mb-0">{organizationTree?.name}</h4>
          </div>

          {/* Tabs Navigation */}
          <Nav tabs className="mt-4">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '1' })}
                onClick={() => toggleTab('1')}
              >
                Organization Information
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '2' })}
                onClick={() => toggleTab('2')}
              >
                Manage Brands and Stores
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === '3' })}
                onClick={() => toggleTab('3')}
              >
                Types of Campaigns
              </NavLink>
            </NavItem>
          </Nav>

          {/* Tab Content */}
          <TabContent activeTab={activeTab} className="mt-4">
            {/* Edit Organization Information Tab */}
            <TabPane tabId="1">
              <div className="mt-4">
                <ModifyOrganization organization={organizationTree} />
              </div>
            </TabPane>
            {/* Manage Brands and Stores Tab */}
            <TabPane tabId="2">
              <div className="d-flex flex-row align-items-center justify-content-between mt-4">
                <div className="d-flex flex-row align-items-center">
                  <div
                    style={{
                      width: 5,
                      height: 20,
                      backgroundColor: '#4b38b3',
                      marginRight: 8,
                    }}
                  />
                  <span className="fs-16">
                    <strong>Available Brands</strong>
                  </span>
                </div>
                <CreateBrandPopup />
              </div>
              {brands?.length > 0 ? (
                <div className="mt-3 d-flex flex-row gap-2">
                  {brands?.map((brand, index) => (
                    <div
                      className={`px-4 py-2 border rounded bg-light cursor-pointer ${
                        brand?.brandId === selectedBrand?.brandId
                          ? 'border-primary'
                          : ''
                      }`}
                      key={brand?.id}
                      onClick={() => handleBrandClick(brand)}
                    >
                      <span className="fs-16 fw-semibold">{brand?.name}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="m-4">
                  The brand does not exist for the{' '}
                  <strong>{organizationTree?.name}</strong>, Please create new
                  brand.
                </div>
              )}

              <AvailableStores selectedBrand={selectedBrand} />
            </TabPane>

            {/* Types of Campaigns Tab */}
            <TabPane tabId="3">
              <div className="mt-4">
                <h5>Types of Campaigns</h5>
                <CampaignTypeList //Copilot make it dynamic
                />
              </div>
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </div>
  );
};

export default OrganizationManagement;
